import {Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import {AttachmentsService} from "../../../services-otc/attachments.service";
import {NavBarComponent} from "../../../../nav-bar/nav-bar.component";
import {catchError, throwError} from "rxjs";

@Component({
    selector: 'app-attach-item',
    templateUrl: './attach-item.component.html',
    styleUrls: ['./attach-item.component.css'],
    standalone: false
})
export class AttachItemComponent {
  @ViewChild('fileInput') fileInput: ElementRef;

  newAttachmentForm: FormGroup;
  description: string;
  fileName: string;
  fileObj: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private newAttachmentFb: FormBuilder,
              public dialogRef: MatDialogRef<OrderComponent>,
              private attachmentsService: AttachmentsService,
              public nav: NavBarComponent,
  ) {
    this.newAttachmentForm = this.newAttachmentFb.group({
      description: new FormControl(''),
      fileUrl: new FormControl(''),
    });
  }

  cancelAddingAttachment(){
    this.dialogRef.close(false);
  }

  selectNewAttachment(event) {
    const file: File = event.target.files[0];
    //handle the selected file here
    this.fileName = file.name.length > 20 ? file.name.slice(0,15) + '...' : file.name;
    this.fileObj = file;
  }

  uploadNewAttachment() {
    this.nav.toggleLoading(true);

    //Added this check since the component is best to be reused in Lab Manager as well
    if(this.data?.isLabManagerComp) {
      this.dialogRef.close({
        description: this.newAttachmentForm.get('description').value,
        fileObj: this.fileObj
      });
    } else if(this.data.orderId) {
      let attachmentObj = {
        description: this.newAttachmentForm.get('description').value,
        orderId: this.data.orderId,
      };
      this.attachmentsService.postNewAttachment(attachmentObj.orderId, attachmentObj.description, this.fileObj).pipe(
          catchError(error => {
            console.error(error);
            return throwError(() => error);
          })
      ).subscribe(() => {
        this.dialogRef.close(true);
      });

    }
  }
}
